import React from "react";
import Style from "./index.module.scss";
import FileIcon from "../../../../../Courseware/components/FileIcon";
import iconView from "./img/view.png";
import iconDownload from "./img/download.png";
import { Tooltip } from "antd";
import { ListProps } from "../../../../../../../components/PreviewSourceModal/servers";

interface Props {
    data: ListProps;
    onPrev?: (id: number | string) => void;
    showTools?: boolean;
    children?: React.ReactChild;
}
const Index = ({ data, onPrev, showTools = true, children }: Props) => {
    return (
        <div className={Style.root}>
            <FileIcon className={Style.icon} ext={data.fileType} />
            <div className={Style.middle}>
                <h1 className={Style.title}>
                    <Tooltip title={data?.fileName} placement="topLeft">
                        {data?.fileName}
                    </Tooltip>
                </h1>
                <p className={Style.info}>大小 {data?.fileSize}</p>
            </div>
            {showTools && (
                <div className={Style.tools}>
                    <a
                        href={`${data?.fileUrl}?attname=${encodeURIComponent(
                            data.fileName
                        )}`}>
                        <img src={iconDownload} alt="" />
                    </a>
                    <img
                        src={iconView}
                        alt=""
                        onClick={() => onPrev?.(data?.id)}
                    />
                    {children}
                </div>
            )}
        </div>
    );
};

export default Index;
